import React, { Fragment } from "react";
import {
    convert_to_Thaidatetime,
    createMarkup,
    moment_datetime,
} from "../../../helpers/functions";
import { Link } from "react-router-dom";
import ShowFileDowload from "./ShowFileDowload";
import InterestedContent from "../../components/Utils/InterestedContent";

function ShowContent({ data }) {

    const extractVideoId = (url) => {
        const match = url && url.match(/[?&]v=([^&]+)/);
        return match ? match[1] : null;
    };

    return (
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 min-h-screen">
            <div className="grid grid-cols-12 mt-2">

                <div className="col-span-12 md:col-span-12">
                    <h2 className="news-title font-medium text-base  md:text-lg lg:text-2xl text-gray-700">
                        {data.show && data.show.Question}
                    </h2>
                    <div className="news-header-line border-b-4 border-[#2F9DFF] pb-2">
                        <div className="item inline-block mr-5 text-gray-500 font-light">
                            <i className="fa fa-clock-o" />
                            &nbsp;{data.show && moment_datetime(data.show.Date)}
                        </div>
                        <div className="item inline-block mr-5 text-gray-500 font-light">
                            <i className="fa fa-eye" />
                            &nbsp;{data.show && data.show.pageview}
                        </div>
                    </div>
                    {data.show && data.show.Category == "headslide" ? (
                        <div className="w-full my-2">
                            {data.show.nphoto === "" ||
                                data.show.nphoto == null ||
                                (data.show.nphoto &&
                                    data.show.nphoto.length < 5) ? (
                                <Fragment></Fragment>
                            ) : (
                                <img
                                    src={`${data.show.nphoto}`}
                                    alt={`...`}
                                    className={`w-full h-auto object-cover object-top`}
                                />
                            )}
                        </div>
                    ) : (
                        <></>
                    )}

                    {data.show && data.show.nmedia && data.show.nmedia != null &&
                        <div className="p-5 flex justify-center">
                            <iframe
                                src={`https://www.youtube.com/embed/${extractVideoId(
                                    data.show && data.show.nmedia
                                )}`}
                                title="YouTube video"
                                width="560"
                                height="315"
                                allowFullScreen
                                className="rounded-xl shadow-lg"
                            ></iframe>
                        </div>
                    }
                    <div
                        className="p-5 w-auto grid"
                        id="showcontaincoop"
                        dangerouslySetInnerHTML={createMarkup(
                            data.show && data.show.Note
                        )}
                        style={
                            data.show && data.show.Note == ""
                                ? { padding: 0 }
                                : {}
                        }
                    ></div>
                    <div className="">
                        <div className="row">
                            <div className="col-md-12">
                                {data.show && data.show.ndata && (
                                    <ShowFileDowload
                                        data={data.show}
                                        nlink={data.show.nlink}
                                    />
                                )}

                                <div className="news-picture-item">
                                    <div style={{ clear: "both" }} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 text-left"></div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-3">
                    {/* <InterestedContent /> */}
                </div>
            </div>
        </div>
    );
}

export default ShowContent;
